import React from 'react'

import FirebaseControlQuery from '@src/firebase-util/firebase-control-query'
import { TokenPayloadInterface } from '@src/store/actionSlices/token'
import { ProjectIdentity, SessionMap } from '@src/store/types'

import { hasToken } from './helper'
import useMatrixCacheCleaner from './matrix-cache-cleaner'

interface ClearCacheTriggerHandlerProps {
  token: TokenPayloadInterface
  session: SessionMap | undefined
  projectIdentity: ProjectIdentity
}

function ClearCacheTriggerHandler({
  token,
  session,
  projectIdentity,
}: ClearCacheTriggerHandlerProps) {
  const firebaseControlQuery = FirebaseControlQuery({
    ...projectIdentity,
    sessionKeys: projectIdentity.sessionId,
  })

  const [isMatrixCacheCleaned, handleMatrixCacheCleanerTrigger] =
    useMatrixCacheCleaner({
      projectName: projectIdentity.projectName,
      email: token.email,
    })

  const resetClearCacheTriggerKeyFromFirebaseAndReload = async () => {
    await firebaseControlQuery.update({
      [`clearCacheTriggerKey`]: '',
      [`clearCacheKeyState`]: 'cleared',
    })
    window.location.reload()
  }

  React.useEffect(() => {
    if (isMatrixCacheCleaned) {
      resetClearCacheTriggerKeyFromFirebaseAndReload()
    }
  }, [isMatrixCacheCleaned])

  React.useEffect(() => {
    if (hasToken(token) && session) {
      const { clearCacheTriggerKey: firebaseClearCacheTriggerKey } = session
      handleMatrixCacheCleanerTrigger(firebaseClearCacheTriggerKey !== '')
    }
  }, [session])

  return true
}

export default ClearCacheTriggerHandler
